module.exports = __webpack_public_path__ + "img/boule_doree.9baa1983.png";